import(/* webpackMode: "eager" */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/app/[locale]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/app/[locale]/HeaderFooterWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/components/AppOpenTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/components/GTMInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2669709893/src/mila_me_frontend_customer/node_modules/next/dist/client/script.js");
